import RefreshModal from '@/core/components/RefreshModal.vue';

const RefreshModalPlugin = {
    install (Vue) {
        Vue.prototype.$refreshModal = function () {
            if (document.getElementById('refresh-page-modal')) {
                return;
            }

            const ModalConstructor = Vue.extend(RefreshModal);

            const instance = new ModalConstructor({
                i18n:  this.$i18n,
                store: this.$store
            });

            instance.$mount();

            document.body.appendChild(instance.$el);
        };
    }
};

export default RefreshModalPlugin;
